<div class="content">
  <div class="content-panel">
    <div class="searchBar">
      <label class="form-label" for="searchBar-input" translate>page.admin.utilisateur.liste.table.filtrer</label>
      <input type="text" id="searchBar-input" (ngModelChange)="searchStringUpdate.next($event)" [(ngModel)]="searchStringInput"
        placeholder="{{'label.filtre'|translate}}">
    </div>

    <div class="actions-bar" *hasRole="'INTERVENANT_UTILISATEUR_ECRITURE'">
      <button type="button" (click)="addUtilisateur()" (keydown.enter)="addUtilisateur()" class="btn btn-primary">Ajouter</button>
    </div>
    <div class="tableScroll">
      @if (utilisateurs) {
        <table class="table table-striped" aria-label="Liste des utilisateurs">
          <thead class="sticky-top">
            <tr>
              <th scope="col" class="actif-column"></th>
              <th><ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'email', libelle:'page.admin.utilisateur.liste.table.header.email'}"></ng-container></th>
              <th><ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'nom', libelle:'page.admin.utilisateur.liste.table.header.nom'}"></ng-container></th>
              <th><ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'prenom', libelle:'page.admin.utilisateur.liste.table.header.prenom'}"></ng-container></th>
              @if (!isAnpp()) {
                <th>
                  <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'type.libelle', libelle:'page.admin.utilisateur.liste.table.header.type'}"></ng-container>
                </th>
                <th>
                  <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'dateCreation', libelle:'page.admin.utilisateur.liste.table.header.dateCreation'}"></ng-container>
                </th>
              } @else {
                <th>
                  <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'entreprise.raisonSociale', libelle:'page.admin.utilisateur.liste.table.header.entreprise'}"></ng-container>
                </th>
                <th>
                  <ng-container *ngTemplateOutlet="tableHeader;context:{sortProperty:'notificationDocumentaire', libelle:'page.admin.utilisateur.liste.table.header.notification-documentaire'}"></ng-container>
                </th>
              }
              <th *hasRole="'INTERVENANT_UTILISATEUR_ECRITURE'"></th>
            </tr>
          </thead>
          <tbody>
            @for (utilisateur of utilisateurs | filter: ['email','nom','prenom','entreprise']:searchString | orderBy:order.property:order.reverse:true; track utilisateur.id) {
              <tr>
                <td>
                  <app-utilisateur-statut [utilisateur]="utilisateur"></app-utilisateur-statut>
                </td>
                <td>{{utilisateur.email}}</td>
                <td>{{utilisateur.nom}}</td>
                <td>{{utilisateur.prenom}}</td>
                @if (!isAnpp()) {
                  <td>{{utilisateur.type?.libelle}}</td>
                  <td>{{utilisateur.dateCreation | date:'shortDate'}}</td>
                } @else {
                  <td>{{ utilisateur.entreprise != null ? utilisateur.entreprise.raisonSociale : '' }}</td>
                  <td>{{ utilisateur.notificationDocumentaire ? 'Oui' : 'Non' }}</td>
                }
                <td *hasRole="'INTERVENANT_UTILISATEUR_ECRITURE'" class="actions">
                  <span *hasRole="'INTERVENANT_UTILISATEUR_LECTURE || INTERVENANT_UTILISATEUR_ECRITURE'">
                    @if (!isAdmin(utilisateur) && !isAnpp() && !utilisateur.utilisateurAnpp) {
                      <fa-icon class="clickable-icon" icon="user-tag" (click)="editUtilisateurDroits(utilisateur)" (keydown.enter)="editUtilisateurDroits(utilisateur)"></fa-icon>
                    }
                  </span>
                  <span><fa-icon class="clickable-icon" icon="edit" (click)="editUtilisateur(utilisateur)" (keydown.enter)="editUtilisateur(utilisateur)"></fa-icon></span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>

<ng-template #tableHeader let-property="sortProperty" let-libelle="libelle">
  @if (property) {
    <th (click)="setOrder(property)" (keydown.enter)="setOrder(property)" [class.sortable]="property">
      {{libelle | translate}}
      <fa-icon [icon]="getIcon(property)"></fa-icon>
    </th>
  } @else {
    <th>{{libelle | translate}}</th>
  }
</ng-template>
